/**
 * Замечание для разработчиков
 *
 * При изменении библиотеки Forms не забудьте обновить ее подключение в плагине
 *
 * @see import('@/core/core/plugin')
 */

import type { ComponentCustomProps } from 'vue';

import Avatar from './avatar/avatar.vue';
import Button from './button/button.vue';
import Checkbox from './checkbox/checkbox.vue';
import ControlLabel from './controlLabel/controlLabel.vue';
import Hint from './hint/hint.vue';
import Input from './input/input.vue';
import InputDate from './inputDate/inputDate.vue';
import InputRange from './inputRange/inputRange.vue';
import Radio from './radio/radio.vue';
import Switcher from './switcher/switcher.vue';
import Textarea from './textarea/textarea.vue';
import Select from './select/select.vue';
import Loadbar from './loadbar/loadbar.vue';
import Preloader from './preloader/preloader.vue';

// Для не SFC, чтобы работало автозаполнение в template в ComponentOptions
// Имена намеренно делаются разными, чтобы типы не конфликтовали: `Button` и `TopButton`

export const TopAvatar = Avatar as typeof Avatar & ComponentCustomProps;
export const TopButton = Button as typeof Button & ComponentCustomProps;
export const TopCheckbox = Checkbox as typeof Checkbox & ComponentCustomProps;
export const TopControlLabel = ControlLabel as typeof ControlLabel & ComponentCustomProps;
export const TopHint = Hint as typeof Hint & ComponentCustomProps;
export const TopInput = Input as typeof Input & ComponentCustomProps;
export const TopInputDate = InputDate as typeof InputDate & ComponentCustomProps;
export const TopInputRange = InputRange as typeof InputRange & ComponentCustomProps;
export const TopRadio = Radio as typeof Radio & ComponentCustomProps;
export const TopSwitcher = Switcher as typeof Switcher & ComponentCustomProps;
export const TopTextarea = Textarea as typeof Textarea & ComponentCustomProps;
export const TopSelect = Select as typeof Select & ComponentCustomProps;
export const TopLoadbar = Loadbar as typeof Loadbar & ComponentCustomProps;
export const TopPreloader = Preloader as typeof Preloader & ComponentCustomProps;
